import { useLocation, useParams } from 'react-router-dom';

import OpuOverview from '../../features/opu/layouts/overview';
import OpuCreate from '../../features/opu/layouts/create';
import OpuLanding from '../../features/opu/layouts/landing';

// TSS vite/01 §"Pages are thin".
// /admin/opu · /admin/opu/new (step 1 modal) · /admin/opu/:id (session landing)
export default function OpuPage() {
    const { id } = useParams();
    const { pathname } = useLocation();
    if (pathname.endsWith('/new')) return <OpuCreate />;
    if (id) return <OpuLanding sessionId={id} />;
    return <OpuOverview />;
}
